export default __webpack_public_path__ + "static/media/add-surgical-order.edf033b7.svg";